import request from '@/utils/request'

/**
 * 获取角色列表
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: Array<{
 *     id: number,
 *     roleName: string,
 *     roleCode: string,
 *     description: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }>
 * }>} 角色列表
 */
export function getRoleList() {
  return request({
    url: '/role',
    method: 'get'
  })
}

/**
 * 获取角色详情
 * @param {number} id 角色ID
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: {
 *     id: number,
 *     roleName: string,
 *     roleCode: string,
 *     description: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }
 * }>} 角色详情
 */
export function getRoleById(id) {
  return request({
    url: `/role/${id}`,
    method: 'get'
  })
}

/**
 * 创建角色
 * @param {Object} data 角色数据
 * @param {string} data.roleName 角色名称
 * @param {string} data.roleCode 角色编码
 * @param {string} [data.description] 角色描述
 * @param {number} [data.status=1] 状态：1-启用，0-禁用
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: {
 *     id: number,
 *     roleName: string,
 *     roleCode: string,
 *     description: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }
 * }>} 创建的角色信息
 */
export function createRole(data) {
  return request({
    url: '/role',
    method: 'post',
    data
  })
}

/**
 * 更新角色
 * @param {number} id 角色ID
 * @param {Object} data 角色数据
 * @param {string} data.roleName 角色名称
 * @param {string} data.roleCode 角色编码
 * @param {string} [data.description] 角色描述
 * @param {number} [data.status] 状态：1-启用，0-禁用
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: {
 *     id: number,
 *     roleName: string,
 *     roleCode: string,
 *     description: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }
 * }>} 更新后的角色信息
 */
export function updateRole(id, data) {
  return request({
    url: `/role/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除角色
 * @param {number} id 角色ID
 * @returns {Promise<{
 *   code: number,
 *   message: string
 * }>} 删除结果
 */
export function deleteRole(id) {
  return request({
    url: `/role/${id}`,
    method: 'delete'
  })
}

/**
 * 获取角色权限
 * @param {number} roleId 角色ID
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: Array<{
 *     id: number,
 *     permissionName: string,
 *     permissionCode: string,
 *     type: string,
 *     parentId: number,
 *     path: string,
 *     component: string,
 *     sort: number,
 *     icon: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }>
 * }>} 角色权限列表
 */
export function getRolePermissions(roleId) {
  return request({
    url: `/role/${roleId}/permissions`,
    method: 'get'
  })
}

/**
 * 分配角色权限
 * @param {Object} data 权限分配数据
 * @param {number} data.roleId 角色ID
 * @param {Array<number>} data.permissionIds 权限ID列表
 * @returns {Promise<{
 *   code: number,
 *   message: string
 * }>} 分配结果
 */
export function assignRolePermissions(data) {
  return request({
    url: '/role/assign-permissions',
    method: 'post',
    data
  })
} 